import { useEffect, useState } from 'react';
import { ListGroup } from 'react-bootstrap';
import { getModuleDataByGroupId, getModuleDataByModuleId } from './Util/Utilities';

function EventTypeSelection({ activeKey, setActiveKey, eventTypeList, setEventTypeList, handleModuleChange }) {
    const [activeModuleName, setActiveModuleName] = useState(null);
    const [visibleSub, setVisibleSub] = useState(null);
    
    //Set the active event type
    useEffect(()=>{
        if(eventTypeList!=null){
            //console.log(eventTypeList);
            //console.log(activeKey);
            setActiveModuleName(eventTypeList.find((m => m.id==activeKey)));
            var r = getModuleDataByModuleId(activeKey, eventTypeList);
            //console.log(r);
            if(r!=null){
                setActiveModuleName(r.moduleName);
                if(r.subModuleName==null){
                    displaySubModule(null);
                }
            }
            else{
                var d = getModuleDataByGroupId(activeKey, eventTypeList);

                setActiveModuleName(d.moduleName);
                if(d.subModuleName==null){
                    displaySubModule(null);
                }
            }
            
            
            
        } 
    },[activeKey])

   

    const displaySubModule = (mod) => {
        setVisibleSub(mod);
    }

    //handleModuleChange(moduleData, getSearchModuleData(searchTerm,m.moduleId, m.docId));
    
    return (
        <ListGroup className="shadow2 bg-color-base-white col-md-12 p-3" >
            <ListGroup.Item className="body  color-base-black">
                Which <b>event type</b> are you interested in providing feedback on?
            </ListGroup.Item>
            {
                eventTypeList.map((mod, index) => {
                    if(mod.hasOwnProperty("subs")){
                        return (
                        <>
                            <ListGroup.Item
                                action 
                                title={visibleSub==mod.moduleName ? "Close sub-event type" : "Open sub-event type"}
                                className={"d-flex py-0 w-100 justify-content-between align-items-center sub-module-control " + (visibleSub==mod.moduleName ? "open" : "")}
                                active={activeModuleName == mod.moduleName} 
                                disabled={activeModuleName == mod.moduleName ? "disabled" : ""}
                                onClick={(e)=>{
                                    if(visibleSub==mod.moduleName){
                                        if(activeModuleName != mod.moduleName){
                                            displaySubModule(null);
                                        }
                                    }
                                    else{
                                        displaySubModule(mod.moduleName);
                                    }
                                }}
                                key={"module-"+mod.id}
                            >
                                {mod.moduleName}
                                {   
                                    activeModuleName!=null
                                    ?   
                                    
                                        <svg className={!(visibleSub!= null && visibleSub==mod.moduleName ) && (activeModuleName!=mod.moduleName) ? "down-icon" : 'up-icon'} xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none">
                                            <path d="M1.41 7.41L6 2.83L10.59 7.41L12 6L6 3.8147e-06L0 6L1.41 7.41Z" fill="#1D6193"/>
                                        </svg>
                                    :   null
                        }
                            </ListGroup.Item>
                            <ListGroup hidden={!(visibleSub!= null && visibleSub==mod.moduleName ) && (activeModuleName!=mod.moduleName) ?"hidden": ""} className="px-0 mt-0 py-0">
                                {/* <ListGroup.Item className="body color-base-black"><b>Which type of {mod.moduleName} event are you interested in providing feedback on?</b></ListGroup.Item> */}
                                {
                                    mod['subs'].map((s) =>{
                                        return(
                                            <ListGroup.Item 
                                                action 
                                                eventKey={s.id} 
                                                active={activeKey == s.id} 
                                                disabled={activeKey == s.id ? "disabled" : ""} 
                                                onClick={()=>{
                                                    setActiveModuleName(s.moduleName);
                                                    handleModuleChange(s);
                                                }}
                                                className="ps-4"
                                            >
                                                {s.subModuleName} 
                                            </ListGroup.Item>
                                        )
                                    })
                                }
                            </ListGroup>
                        </>

                            
                        )
                    }
                    else{
                        return(
                            <ListGroup.Item 
                                action 
                                eventKey={mod.id} 
                                active={activeKey == mod.id} 
                                disabled={activeKey == mod.id ? "disabled" : ""} 
                                onClick={()=>{
                                    setActiveModuleName(mod.moduleName);
                                    displaySubModule(null);
                                    handleModuleChange(mod);
                                }}
                                key={"module-"+mod.id}
                            >
                                {mod.moduleName} 
                            </ListGroup.Item>
                        );
                        
                    }
                    
                })

            }
            
        </ListGroup>
        
    );
}

export default EventTypeSelection;